<div class="lay-container">
  <button mat-raised-button 
    #addQuestion
    class="add-button m-t-md" 
    color="primary" 
    (click)="openHideList()">
    <i class="ae ae-plus-bolt"></i>
    {{ "questionnaire.addQuestion" | translate}}
  </button>

  <div class="list-holder"  *ngIf="displayList">
    <div class="title-holder">
      <span>
        {{ "common.selectYourType" | translate }}
      </span>
      <i class="ae ae-times close-icon" (click)="openHideList()"></i>
    </div>
    <div class="list-childs">
      <ng-container *ngFor="let type of questionTypes;">
        <div class="list-item" (click)="setSelection(type)">
          <span class="icon-holder">
              <i class="ae {{type?.icon}}"></i>
          </span>
          <span class="label-content">
            {{ type?.questionTypeName}}
          </span>
        </div>
      </ng-container>
    </div>
  </div>
</div>